/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Delete_Button_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Delete Event" |
*
* @param {Event_Delete_Button_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_delete_button_aria_label = /** @type {((inputs?: Event_Delete_Button_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Delete_Button_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer l'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Löschereignis")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट हटाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir evento")
	return /** @type {LocalizedString} */ ("Delete Event")
});